import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useCart } from '../../context/CartContext';
import logoImg from '../../assets/logo-maxServicios.png';
import './Navbar.css';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const { user, isAuthenticated, logout } = useAuth();
  const { itemCount } = useCart();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    setUserMenuOpen(false);
    setMenuOpen(false);
    navigate('/');
  };


  const closeMenus = () => {
    setMenuOpen(false);
    setUserMenuOpen(false);
    // Hacer scroll al top cuando se cierra el menú
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  };

  const handleLinkClick = () => {
    closeMenus();
    // Asegurar scroll al top después de un pequeño delay para que la navegación se complete
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    }, 100);
  };

  return (
    <>
      <nav className="navbar">
        <div className="container">
          <div className="navbar-content">
            {/* Logo */}
            <Link to="/" className="navbar-brand" onClick={closeMenus}>
              <img src={logoImg} alt="MaxServicios" className="navbar-logo-img" />
              {/* <span className="navbar-brand-text">MaxServicios</span> */}
            </Link>

            {/* Mobile Toggle */}
            <button
              className={`navbar-toggle ${menuOpen ? 'navbar-toggle-active' : ''}`}
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label="Toggle menu"
              aria-expanded={menuOpen}
            >
              <span></span>
              <span></span>
              <span></span>
            </button>

            {/* Navigation Links - Desktop */}
            <div className="navbar-menu-desktop">
              <Link to="/" className="navbar-link">
                Inicio
              </Link>
              <Link to="/products" className="navbar-link">
                Productos
              </Link>
              <Link to="/about" className="navbar-link">
                Nosotros
              </Link>
              <Link to="/faq" className="navbar-link">
                FAQ
              </Link>
              <Link to="/contact" className="navbar-link">
                Contacto
              </Link>
            </div>

            {/* Actions - Desktop */}
            <div className="navbar-actions-desktop">
            {/* Search Bar */}
            {/* <form className="navbar-search" onSubmit={handleSearch}>
              <input
                type="text"
                placeholder="Buscar productos..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="navbar-search-input"
              />
              <button type="submit" className="navbar-search-btn" aria-label="Buscar">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="11" cy="11" r="8"></circle>
                  <path d="m21 21-4.35-4.35"></path>
                </svg>
              </button>
            </form> */}

            {/* Wishlist */}
            {isAuthenticated() && (
              <Link to="/wishlist" className="navbar-action-btn" aria-label="Wishlist" onClick={closeMenus}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
                </svg>
              </Link>
            )}

            {/* Cart */}
            <Link to="/cart" className="navbar-action-btn navbar-cart-btn" aria-label="Shopping cart" onClick={closeMenus}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
                <line x1="3" y1="6" x2="21" y2="6"></line>
                <path d="M16 10a4 4 0 0 1-8 0"></path>
              </svg>
              {itemCount > 0 && (
                <span className="navbar-cart-badge">{itemCount}</span>
              )}
            </Link>

            {/* User Menu */}
            {isAuthenticated() ? (
              <div className="navbar-user-menu">
                <button
                  className="navbar-user-btn"
                  onClick={() => setUserMenuOpen(!userMenuOpen)}
                  aria-label="User menu"
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                    <circle cx="12" cy="7" r="4"></circle>
                  </svg>
                  <span className="navbar-user-name">{user?.name}</span>
                </button>

                {userMenuOpen && (
                  <div className="navbar-user-dropdown">
                    <Link to="/profile" className="navbar-dropdown-item" onClick={closeMenus}>
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                        <circle cx="12" cy="7" r="4"></circle>
                      </svg>
                      Mi Perfil
                    </Link>
                    <Link to="/my-orders" className="navbar-dropdown-item" onClick={closeMenus}>
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
                      </svg>
                      Mis Pedidos
                    </Link>
                    <Link to="/wishlist" className="navbar-dropdown-item" onClick={closeMenus}>
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
                      </svg>
                      Favoritos
                    </Link>
                    <div className="navbar-dropdown-divider"></div>
                    <button className="navbar-dropdown-item" onClick={handleLogout}>
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                        <polyline points="16 17 21 12 16 7"></polyline>
                        <line x1="21" y1="12" x2="9" y2="12"></line>
                      </svg>
                      Cerrar Sesión
                    </button>
                  </div>
                )}
              </div>
            ) : (
              <>
              
            </>
            )}
            </div>
          </div>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      {menuOpen && <div className="navbar-overlay" onClick={closeMenus}></div>}

      {/* Mobile Menu */}
      <div className={`navbar-menu-mobile ${menuOpen ? 'navbar-menu-mobile-open' : ''}`}>
        <div className="navbar-menu-mobile-content">
          <Link to="/" className="navbar-link-mobile" onClick={handleLinkClick}>
            Inicio
          </Link>
          <Link to="/products" className="navbar-link-mobile" onClick={handleLinkClick}>
            Productos
          </Link>
          <Link to="/about" className="navbar-link-mobile" onClick={handleLinkClick}>
            Nosotros
          </Link>
          <Link to="/faq" className="navbar-link-mobile" onClick={handleLinkClick}>
            FAQ
          </Link>
          <Link to="/contact" className="navbar-link-mobile" onClick={handleLinkClick}>
            Contacto
          </Link>

          <div className="navbar-mobile-divider"></div>
          
          {/* Cart Link for Mobile */}
          <Link to="/cart" className="navbar-link-mobile" onClick={handleLinkClick}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
                <line x1="3" y1="6" x2="21" y2="6"></line>
                <path d="M16 10a4 4 0 0 1-8 0"></path>
              </svg>
              Carrito
              {itemCount > 0 && (
                <span style={{ 
                  backgroundColor: '#ff4444', 
                  color: 'white', 
                  borderRadius: '50%', 
                  padding: '2px 6px', 
                  fontSize: '12px', 
                  fontWeight: 'bold',
                  minWidth: '18px',
                  height: '18px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  {itemCount}
                </span>
              )}
            </div>
          </Link>

          {/* Mobile Search */}
          {/* <form className="navbar-search-mobile" onSubmit={handleSearch}>
            <input
              type="text"
              placeholder="Buscar productos..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="navbar-search-input-mobile"
            />
            <button type="submit" className="navbar-search-btn-mobile" aria-label="Buscar">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="11" cy="11" r="8"></circle>
                <path d="m21 21-4.35-4.35"></path>
              </svg>
            </button>
          </form> */}

          {/* Mobile User Actions */}
          {isAuthenticated() ? (
            <>
              <div className="navbar-mobile-divider"></div>
              <Link to="/profile" className="navbar-link-mobile" onClick={handleLinkClick}>
                Mi Perfil
              </Link>
              <Link to="/my-orders" className="navbar-link-mobile" onClick={handleLinkClick}>
                Mis Pedidos
              </Link>
              <Link to="/wishlist" className="navbar-link-mobile" onClick={handleLinkClick}>
                Favoritos
              </Link>
              <button className="navbar-link-mobile navbar-link-mobile-logout" onClick={handleLogout}>
                Cerrar Sesión
              </button>
            </>
          ) : (
            <>
              
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default Navbar;
